<template>
  <v-row no-gutters align="center">
    <v-col cols="auto">
      <div class="container-width px-2"><POISnapshot /></div
    ></v-col>
  </v-row>
</template>
<script>
import POISnapshot from "../components/POISnapshot";

export default {
  name: "Snapshot",
  components: { POISnapshot },
  data: () => ({}),
  methods: {},
  computed: {},
};
</script>
<style  scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}
</style>
